export enum ShippingDetailsStatus {
  Draft = 0,
  Saved = 1
};
